import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of as observableOf, Observable } from 'rxjs';
import { ErrorResponse, SuccessResponse } from '../../response';
import { IGDPRDataPrivacySettings } from './gdpr-data-privacy.model';

@Injectable({ providedIn: 'root' })
export class GDPRDataPrivacyService {

    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${GDPRDataPrivacyService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'contactdataprivacies';

    public getSettings(): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<any>>(GDPRDataPrivacyService.URL).pipe(
                catchError(error => observableOf(new ErrorResponse(error?.error?.messages))));
    }

    public editSettings(model: IGDPRDataPrivacySettings): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<any>>(GDPRDataPrivacyService.URL, model).pipe(
                catchError(error => observableOf(new ErrorResponse(error?.error?.messages))));
    }

    public getFilteredContacts(model: any): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(GDPRDataPrivacyService.URL, model).pipe(
                catchError(error => observableOf(new ErrorResponse(error?.error?.messages))));
    }
}
